import React, { ReactElement } from 'react';
import { Trans, useTranslation } from 'next-i18next';

const SeoCopySection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$seoCopySection' });

  return (
    <section className="base-section seo-section">
      <div className="seo-copy tagline">
        <h2 className="banner-title">{t('seoTitle')}</h2>
        <p>
          <Trans i18nKey="seoText" t={t} components={{ span: <span /> }} />
        </p>
      </div>
    </section>
  );
};

export default SeoCopySection;
